"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './ListSummary.module.scss.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import clsx from 'clsx';

const ListSummary = flowComponent("ListSummary", (props) => {
  const { children, position = "top", ref } = props;
  if (position === "bottom") {
    return /* @__PURE__ */ jsx(
      "footer",
      {
        ref,
        className: clsx(styles.listSummary, styles.bottom),
        ...props,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "header",
    {
      ref,
      className: clsx(styles.listSummary, styles.top),
      ...props,
      children
    }
  );
});

export { ListSummary, ListSummary as default };
//# sourceMappingURL=ListSummary.mjs.map
